let activeFeedSeed = '';

function makeFeedSeed() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

/** Default home feed sort for guests and signed-in members. */
export function defaultHomeFeedSort() {
  return 'recommended';
}

/**
 * Per-visit seed: new on each full page load, stable while navigating inside the SPA
 * (so infinite scroll pagination stays consistent).
 */
export function getFeedPersonalizationSeed({ forceNew = false } = {}) {
  if (forceNew || !activeFeedSeed) {
    activeFeedSeed = makeFeedSeed();
  }
  return activeFeedSeed;
}

export function resetFeedPersonalizationSeed() {
  return getFeedPersonalizationSeed({ forceNew: true });
}
